import React, { useEffect, useState } from 'react';

import { Select, SelectOption } from '../Select';
import { useField } from 'react-final-form';
import { useConfiguration } from '../../providers/Configuration';
import { useOptions } from '../../providers/Options';
import { fetchJSONP, normalizeOptions } from '../../services/common.service';
import { useTranslation } from 'react-i18next';
import { combineValidators, required } from '../../services/validators.service';

const INITIAL_OPTION = { description: '', value: 'Välj här' };
export default function DropDown({ label, catJSONMap = [], defaultOption, form, ...props }) {
    const { t } = useTranslation();

    const combinedValidations = combineValidators([required(t('empty_mandatory_error'))]);

    /**
     * TODO: This should be Separate custom DropDown components in each of the formType containers.
     *
     * This is for backwards compatability. In the angular implementation, DropDown accts diferent depending on what formType it is.
     *
     */
    const {
        configuration: {
            componentData: { categoryServiceUrl, categoryServiceUrlFUP, formtype }
        }
    } = useConfiguration();
    const [globalOptions, setGlobalOptions] = useOptions();
    const [localFetchedOptions, setLocalFetchedOptions] = useState([]);
    const { input, meta } = useField(props.name, { initialValue: props.value, validate: combinedValidations });
    // To handle the dynamic fetching of data from SDL which differ depending on formType
    // sometimes it fetches from JSONP sometimes it does a regular fetch to to get a json file in the angular package
    const { value, name } = input;

    useEffect(() => {
        /**
         * Fetch the options from the categoryServiceUrl
         */
        async function fetchGlobalOptionsJSONP(url) {
            const serviceOptions = await fetchJSONP(url);
            setGlobalOptions(opt => [INITIAL_OPTION, ...normalizeOptions(serviceOptions)]);
        }
        async function fetchGlobalOptionsJSONFile(url) {
            const serviceOptions = await (await fetch(url)).json();
            setGlobalOptions(opt => [INITIAL_OPTION, ...normalizeOptions(serviceOptions)]);
        }
        async function fetchLocalOptions(url) {
            const serviceOptions = await (await fetch(url)).json();
            setLocalFetchedOptions(normalizeOptions(serviceOptions));
        }
        async function fetchLocalOptionsJSONP(url) {
            const serviceOptions = await fetchJSONP(url);
            setLocalFetchedOptions(normalizeOptions(serviceOptions));
        }
        async function fetchLocalOptionsJSONFile(url) {
            const serviceOptions = await fetch(url);
            setLocalFetchedOptions(normalizeOptions(serviceOptions));
        }

        /**
         * if the formtype is of DynamicMultiService, then the options fetched, is meant for another Dropdown in the UI.
         * if the fieldId is 'select-type' then its the fetching dropdown
         */
        if (formtype === 'DynamicMultiService' && props.fieldId === 'select-type' && value) {
            if (categoryServiceUrl) {
                fetchGlobalOptionsJSONP(`${categoryServiceUrl}/${value}`);
            } else {
                // if the categoryServiceUrl is undefined, we just need to get the coresponding json from the given url + value
                fetchGlobalOptionsJSONFile(`${t('versionPath')}/assets/apps/${value}.json`);
            }
        }

        /**
         * if the formtype is DynamicSingleService we need to check categoryServiceUrlFUP
         */
        if (formtype === 'DynamicSingleService' && catJSONMap.length === 0 && localFetchedOptions.length === 0) {
            if (categoryServiceUrl) {
                fetchLocalOptionsJSONP(`${categoryServiceUrl}/${value}`);
            } else if (categoryServiceUrlFUP) {
                fetchLocalOptions(categoryServiceUrlFUP);
            } else {
                fetchLocalOptionsJSONFile(`${t('versionPath')}/assets/apps/${value}.json`);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    const catJSONOptions = catJSONMap?.reduce(
        (acc, item) => {
            acc.push(item);
            return acc;
        },
        [
            {
                description: '',
                value: defaultOption
            }
        ]
    );

    const localOptions = catJSONOptions.length > 1 ? catJSONOptions : [...catJSONOptions, ...localFetchedOptions];
    const opt = props.fieldId === 'select-model' ? globalOptions : localOptions;

    return opt.length < 100 ? (
        <Select
            label={label}
            {...input}
            meta={meta}
            disabled={opt.length === 0}
            // !Edge case for Boat
            // We need to reset the value for Boat modell select when the value changes in the "Välj båt typ"-select.
            // Need onInput so that we dont override the onchange from the select
            onInput={() => {
                const boatModellSelect = document.getElementById('Båtmodell');
                if (boatModellSelect) {
                    if (name === 'produktklass') {
                        form.change('familj');
                        boatModellSelect.value = defaultOption;
                    }
                }
            }}
        >
            {opt.map((item, index) => {
                return (
                    <SelectOption key={index} value={item.description}>
                        {item.value}
                    </SelectOption>
                );
            })}
        </Select>
    ) : (
        // FUN select cant load large number of options, using native options instead
        // Native select need value={undefined} to set value
        <Select label={label} {...input} meta={meta} disabled={opt.length === 0} value={undefined}>
            {opt.map((item, index) => {
                return (
                    <option key={index} value={item.description}>
                        {item.value}
                    </option>
                );
            })}
        </Select>
    );
}
